import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CheckCircleOutlined, LeftOutlined } from '@ant-design/icons';
import { Button, Form, Input, Space } from 'antd';
import LayoutSmall from 'layouts/LayoutSmall';

import { useForgotPasswordMutation } from '../../generated/graphql';
import { INDEX, LOGIN } from '../../routes';

export const ForgotPassword: FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [success, setSuccess] = useState<boolean>(false);

    const [forgotPassord, forgotPasswordData] = useForgotPasswordMutation();

    const onSubmit = async (data: any) => {
        await forgotPassord({
            variables: {
                email: data.email,
            },
            onCompleted: (data) => {
                if (data.forgotPassword?.ok) {
                    setSuccess(true);
                }
            },
        });
    };

    return (
        <LayoutSmall title={t('Password recovery')}>
            {success &&
                <Space direction={'vertical'} size={16}>
                    <h4 className={'success'}><CheckCircleOutlined/> {t('Email sent')}</h4>
                    <div>{t('Check your incoming mail, including the spam folder')}</div>
                    <Button block type={'primary'} onClick={() => navigate(INDEX)}>
                        {t('Good')}
                    </Button>
                </Space>
            }

            {!success && (
                <Form layout="vertical" onFinish={onSubmit} scrollToFirstError disabled={forgotPasswordData.loading}>
                    <Form.Item
                        name="email"
                        label={t('Email')}
                        rules={[
                            { required: true, message: t('Required')! },
                            { type: 'email', message: t('Invalid format')! },
                        ]}
                    >
                        <Input placeholder="example@site.com" />
                    </Form.Item>

                    <Form.Item>
                        <Button loading={forgotPasswordData.loading} block htmlType={'submit'} type="primary">
                            {t('Recover password')}
                        </Button>
                    </Form.Item>

                    <Button block type={'link'} onClick={() => navigate(LOGIN)} icon={<LeftOutlined/>}>
                        {t('Back')}
                    </Button>
                </Form>
            )}
        </LayoutSmall>
    );
};
